import { IonIcon, useIonToast } from '@ionic/react';
import { checkmarkCircleOutline } from 'ionicons/icons';
import { FC, FormEvent, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReduxCommandCreator } from 'appRedux/actions';
import { IState, IUserInfo } from 'appRedux/createStore';
import { validateEmail } from '../../common/include';
import { toastConfig } from '../../config/ToastConfig';
import { PlayerService } from 'services/player';

// Account Info email: editable inline, saved with the tick once it differs from the stored one.
const EmailSettingRow: FC = () => {
  const userInfo = useSelector<IState>((state) => state.app.persistedState.userInfo) as IUserInfo;
  const { phone, emailAddress } = userInfo ?? {};
  const dispatch = useDispatch();
  const [presentToast] = useIonToast();
  const [email, setEmail] = useState(emailAddress ?? '');
  const [saving, setSaving] = useState(false);

  useEffect(() => setEmail(emailAddress ?? ''), [emailAddress]);

  const trimmed = email.trim();
  const canSave = !!phone && !saving && !!trimmed && trimmed !== (emailAddress ?? '');

  const showToast = (color: 'success' | 'danger', message: string) =>
    void presentToast({ ...toastConfig, color, message });

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (!canSave || !phone) return;
    if (!validateEmail(trimmed)) {
      showToast('danger', 'Please enter a valid email address');
      return;
    }
    setSaving(true);
    new PlayerService()
      .UpdateProfile({ cellNumber: phone.toString(), emailAddress: trimmed })
      .subscribe({
        next() {
          ReduxCommandCreator(dispatch).SetUserInformation({ emailAddress: trimmed });
          showToast('success', 'Email address has been updated');
        },
        error() {
          setSaving(false);
          showToast('danger', 'Something went wrong');
        },
        complete() {
          setSaving(false);
        },
      });
  };

  return (
    <form className="settings-row" onSubmit={handleSubmit}>
      <span className="settings-row__text">
        <label className="settings-row__label" htmlFor="settings-email">
          Email
        </label>
      </span>
      <span className="settings-row__value settings-row__value--input">
        <input
          id="settings-email"
          className="settings-row__input"
          type="email"
          inputMode="email"
          autoComplete="email"
          placeholder="Add email"
          value={email}
          disabled={saving}
          onChange={(e) => setEmail(e.target.value)}
        />
        {canSave && (
          <button type="submit" className="settings-row__save" aria-label="Save email">
            <IonIcon icon={checkmarkCircleOutline} aria-hidden="true" />
          </button>
        )}
      </span>
    </form>
  );
};

export default EmailSettingRow;
